export default "__VITE_ASSET__DNS8LS33__"